import { Formik } from "formik";
import "./ValidatePairingCodeDialog.scss";
import Input from "../../../shared/Input/Input";
import { useLazyValidateBpSiteIdQuery } from "../../../../services/rtkQueryServices/authenticationService";
import { useState, useRef } from "react";
import ConfirmationDialog from "../../../shared/ConfirmationDialog/ConfirmationDialog";
import { ReactComponent as InfoIcon } from "../../../../assets/svg/info_lg.svg";
import * as Yup from "yup";
import { errorMessages } from "../../../../constants/errorMessages";
import { regex } from "../../../../constants/regex";

interface ValidatePairingCodeDialogProps {
  open: boolean;
  bpSiteId?: string;
  applicationUserId?: string;
  onSuccess: () => void;
  onClose: () => void;
}

export function ValidatePairingCodeDialog({ open, bpSiteId, applicationUserId, onSuccess, onClose }: ValidatePairingCodeDialogProps) {
  const [validateBpSiteId] = useLazyValidateBpSiteIdQuery();
  const [errorMessage, setErrorMessage] = useState("");
  const formRef = useRef<any>(null);
  const validationSchema = () =>
    Yup.object({
      pairingCode: Yup.string()
        .required(errorMessages.required("Pairing code"))
        .matches(
          regex.paringCodeRegex,
          () => errorMessages.invalid_PairingCode_Format
        ),
    });
  return (
    <ConfirmationDialog
      open={open}
      onOk={() => formRef.current?.handleSubmit()}
      okButtonName="Verify"
      onClose={onClose}
      contentBody={
        <div className="d-flex flex-column justify-content-center align-items-center"
          style={{ padding: "0 20px", gap: "20px" }}>
          <InfoIcon />
          <div className="dialog-title">
            BP Site ID could not be verified
          </div>
          <p>
            Please enable the integration in BP Premier for 'Precedence Health Care (via Halo Connect)' and provide the pairing code.
          </p>
          <Formik
            innerRef={formRef}
            initialValues={{ pairingCode: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              validateBpSiteId({
                bpSiteId: bpSiteId,
                pairingCode: values.pairingCode,
                applicationUserId: applicationUserId,
                PracticeVerificationInformation:
                "Re-validate BP site with pairing code.",
              })
                .unwrap()
                .then((res) => {
                  if (
                    res.data?.isValidBpSiteId &&
                    res.data?.isSuccessfulSqlConnection) {
                    onSuccess();
                  } else if (!res.data?.isValidBpSiteId) {
                    setErrorMessage(errorMessages.invalid_PairingCode);
                  } else if (!res.data?.isSuccessfulSqlConnection) {
                    setErrorMessage(errorMessages.cannot_connect_to_BP);
                  }
                })
                .catch(() => setErrorMessage("Validation failed"));
            }}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit} className="w-100 validate-pairing-code-form">
                <Input
                  name="pairingCode"
                  label="Pairing Code"
                  placeholder="XXXX-XXXX-XXXX"
                  onChange={formik.handleChange}
                  onInput={() => setErrorMessage("")}
                  value={formik.values.pairingCode}
                  errorMsg={(formik.errors as any).pairingCode || errorMessage}
                  maxLength={14}
                />
              </form>
            )}
          </Formik>
        </div>
      }
      isAlertConfirmation={true}
    />
  );
}